/**
 * Browser and platform detection utilities
 * Used for providing platform-specific authentication experiences
 */

export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toUpperCase();
  
  return {
    isSafari: userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1,
    isChrome: userAgent.indexOf('chrome') !== -1,
    isFirefox: userAgent.indexOf('firefox') !== -1,
    isEdge: userAgent.indexOf('edge') !== -1 || userAgent.indexOf('edg') !== -1,
    isMacOS: platform.indexOf('MAC') >= 0,
    isWindows: platform.indexOf('WIN') >= 0,
    isLinux: platform.indexOf('LINUX') >= 0,
    isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
    userAgent: userAgent,
    platform: platform
  };
};

export const getAuthenticationStrategy = () => {
  const browserInfo = getBrowserInfo();
  
  // Determine the best authentication strategy based on browser/platform
  if (browserInfo.isSafari || browserInfo.isMacOS || browserInfo.isIOS) {
    return {
      preferRedirect: true,
      reason: 'Safari/Mac/iOS environments work better with redirect authentication',
      fallbackAvailable: false
    };
  }
  
  return {
    preferRedirect: false,
    reason: 'Popup authentication preferred with redirect fallback',
    fallbackAvailable: true
  };
};

export const getCompatibilityMessages = () => {
  const browserInfo = getBrowserInfo();
  const messages = [];
  
  if (browserInfo.isSafari) {
    messages.push({
      type: 'info',
      message: 'Safari detected: Using redirect authentication for optimal compatibility.'
    });
  }
  
  if (browserInfo.isMacOS && !browserInfo.isSafari) {
    messages.push({
      type: 'info', 
      message: 'macOS detected: Authentication optimized for your platform.'
    });
  }
  
  if (browserInfo.isIOS) {
    messages.push({
      type: 'info',
      message: 'iOS detected: Using device-optimized authentication flow.'
    });
  }
  
  return messages;
};
